import { impersonateApis } from '@apis/impersonateApis';
import { useMutation } from '@hooks/useMutation';
import { AuthManager } from '@store/AuthManager';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const useUnimpersonate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await impersonateApis.get('/unimpersonate/', {});
      if (response[403]) {
        throw new FormError('ImpersonateError', response[403]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        AuthManager.shared.resetImpersonatedUser();
        AuthManager.shared.resetOriginalUser();

        queryClient.removeQueries();
      },
    },
  );
};
